import { action, makeObservable, observable } from 'mobx';

import { PaginatedCollection } from '@journeyapps-labs/lib-reactor-data-layer';
import { ListUserInvitesResponse } from '@journeyapps-platform/types-accounts-hub';
import { DeveloperInviteModel } from '@journeyapps-platform/lib-journey-core';

import { System } from '../System';

export class ProfileStore {
  @observable
  invitations: PaginatedCollection<DeveloperInviteModel, ListUserInvitesResponse>;

  constructor(protected system: System) {
    this.invitations = new PaginatedCollection<DeveloperInviteModel, ListUserInvitesResponse>({
      transformer: action((res) => {
        return res.objects.map((invite) => system.developerInviteStore.upsert(invite));
      }),
      hasMore: (res) => {
        return res.more;
      }
    });
    makeObservable(this);
  }

  /**
   * Fetched user's invitations with optional additional organization ID filter
   */
  loadInvitations(orgId?: string) {
    const { USER_ID } = this.system.context;

    if (!USER_ID) {
      return console.error(`Could not load user invitations due to missing userID`);
    }

    return this.invitations.loadAll(() => {
      return this.system.clientProvisioner.provisionAccountsV5Client().getUserInvites.paginate({
        user_id: USER_ID as string,
        org_id: orgId
      });
    });
  }
}
